import { useForm } from "react-hook-form"
import * as React from "react"
import { zodResolver } from "@hookform/resolvers/zod"
import { useTranslation } from "react-i18next"

import { createCustomerFormSchema, CustomerFormValues } from "./CustomerForm.types"

export type UseCustomerFormValuesProps = {
  initialValues?: CustomerFormValues
}

const DEFAULT_INITIAL_VALUES: CustomerFormValues = {
  businessRegistrationNumber: "",
  organizationName: "",
  representativeName: "",
  staffs: [],
}

export const useCustomerFormValues = ({
  initialValues,
}: UseCustomerFormValuesProps = {}) => {
  const { t } = useTranslation()

  const schema = React.useMemo(() => {
    return createCustomerFormSchema(t)
  }, [t])

  const form = useForm<CustomerFormValues>({
    defaultValues: {
      ...DEFAULT_INITIAL_VALUES,
      ...initialValues,
    },
    mode: "onSubmit",
    resolver: zodResolver(schema),
  })

  React.useEffect(() => {
    if (initialValues) {
      form.reset(initialValues)
    }
  }, [initialValues, form])

  return form
}
